<template>
  <GModal class="modal--crop-photo normalize-gutter">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>

      <h2 class="modal-heading">UPLOAD IMAGE</h2>
    </div>
    <div slot="body">
      <croppa
        v-model="croppa"
        initial-size="cover"
        :quality="2"
        :height="450"
        :width="450"
        :file-size-limit="5242880"
        :accept="'image/jpg,image/jpeg,image/png'"
        :placeholder="'Click here to upload an image'"
        :placeholder-font-size="14"
        @file-size-exceed="onFileSizeExceed"
        @file-type-mismatch="onFileTypeMismatch"
        @file-choose="onFileChoose"
        @image-remove="removeImage"
      >
      </croppa>

      <p class="copyright hidden-lg hidden-md">Move and scale to zoom or crop</p>
      <p v-if="fileSizeExceed" class="copyright text-center text-error">Maksimal file size 5MB</p>
      <p v-if="fileMismatch" class="copyright text-center text-error">File type anda harus jpep, jpg, dan png</p>
      <div class="text-center">
        <a v-if="file && !isProcessingUpload && notError" href="" class="btn btn-dark" @click.prevent="saveCrop"
          >SAVE</a
        >
        <a v-if="file && isProcessingUpload" href="" class="btn btn-dark" @click.prevent="saveCrop">PROCESSING..</a>
      </div>
    </div>
    <div slot="footer"></div>
  </GModal>
</template>

<script>
import Croppa from 'vue-croppa';

Vue.use(Croppa);

export default {
  name: 'modal-upload-image',
  data() {
    return {
      croppa: {},
      isFileChoose: false,
      fileSizeExceed: false,
      fileMismatch: false,
      fileAfterCrop: '',
      file: '',
      isProcessingUpload: false,
    };
  },
  computed: {
    notError() {
      return !this.fileSizeExceed && !this.fileMismatch;
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', false);
    },
    dataURItoBlob(dataURI) {
      const arr = dataURI.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const byteString = atob(dataURI.split(',')[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mime });
    },
    onFileTypeMismatch(file) {
      this.fileMismatch = true;
    },
    onFileSizeExceed(file) {
      this.fileSizeExceed = true;
    },
    onFileChoose(file) {
      this.fileSizeExceed = false;
      this.fileMismatch = false;
      this.file = file;
    },
    removeImage() {
      this.isFileChoose = false;
      this.fileSizeExceed = false;
    },
    saveCrop() {
      const filenameRandom = Math.floor(100000000000 * Math.random());
      this.isProcessingUpload = true;
      this.fileAfterCrop = this.croppa.generateDataUrl(this.file.type, 0.7);
      const fileTypeBlob = this.dataURItoBlob(this.fileAfterCrop);
      this.$MS_SOCO_PUBLIC_API_URL(`pre-signed-url`, {
        params: {
          fileName: `${filenameRandom}-${this.file.name}`,
          contentType: fileTypeBlob.type,
        },
      })
        .then((response) => {
          delete axios.defaults.withCredentials;
          this.file = {
            fileBase64String: response.data.data.url,
            fileName: response.data.data.key,
          };
          return axios.put(response.data.data.signedUrl, fileTypeBlob, {
            headers: { 'Content-Type': fileTypeBlob.type },
          });
        })
        .then((response) => {
          axios.defaults.withCredentials = true;
          this.isProcessingUpload = false;
          this.$emit('saveFile', {
            fileBase64String: this.file.fileBase64String,
            fileName: this.file.fileName,
          });
        })
        .catch((err) => {
          console.log(error);
          this.isProcessingUpload = false;
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        });
    },
  },
};
</script>
